export default function setNotificationsLastSeen(
  {patch}: any,
  {id}: {id: number},
): Promise<{}> {
  return patch(
    `/users/${id}/notifications-last-seen`,
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/users/setNotificationsLastSeen.tsx